<template>
  <div v-if="body_show" class="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="meacur_top">
      <!-- <h2>{{data.headtitle}}</h2> -->
      <div class="meacur_tx clearfix">
        <img :src="data.headimgurl" />
        <div class="meacur_txr">
          <h3>{{data.nickname}}</h3>
          <h4>{{data.ctime}}</h4>
        </div>
      </div>
    </div>
    <div class="meacur_main meacur_mains">
      <div class="mea_tb"><span>总体水平</span></div>
      <!-- 仪表盘 -->
      <div id="dashboard" class="dashboard"></div>
      <div class="meacur_p">
        <h4>您的产品能力水平对应：</h4>
        <h3>{{data.result}}</h3>
        <h3 style="text-decoration: underline;">{{data.desc}}</h3>
      </div>
    </div>
    <div class="meacur_main">
      <div class="mea_tb"><span>能力水平</span></div>
      <p>通过对腾讯、百度、京东等几大互联网企业的产品经理岗位职责及业务流程梳理，得出产品经理必备的四个方面专业能力：市场能力、产品能力、运营能力和项目管理能力。</p>
      <!-- <p>下图是您在四个维度的得分情况，分值越高，能力越强。</p> -->
      <!-- 雷达图 -->
      <!-- <div id="dimension" class="dimension"></div> -->
      <div class="cdhs">
        <ul>
          <li v-for="(item,index) in cd_list" :key="index"  class="clearfix">
            <span></span>
            <div class="sch_r">
              {{item}}
            </div>
          </li>
        </ul>
      </div>
      <div class="scrie">以下是您在10项专业技能上的具体得分</div>
      <div class="dxs"></div>
      <ve-bar :data="chartData" :settings="chartSettings" class="vs_t"></ve-bar>
    </div>
    <!--  -->
    <div class="meacur_main meacur_mains advertising">
      <div class="mea_tb"><span>职场加速</span></div>
      <p>以上是您的自评结果。如果您想精准评估自己在产品经理岗上的竞争力，为职业发展助力，可以了解下面两个备选方案：</p>
      <ul>
        <li @click="toAdvertising('https://m.qlchat.com/topic/details?topicId=2000005046552922')" class="clearfix">
          <div class="left clearfix">
            <h3>关键扫描版</h3>
            <p>产品经理求职竞争力评估</p>
          </div>
          <img src="@a/key_scan.png" alt="">
        </li>
        <li @click="toAdvertising('https://m.qlchat.com/topic/details?topicId=2000005046656787')" class="clearfix">
          <div class="left clearfix">
            <h3>全面扫描版</h3>
            <p>产品经理求职竞争力评估</p>
          </div>
          <img src="@a/full_scan.png" alt="">
        </li>
      </ul>
    </div>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  ceping57_report,
  ceping57_reset
} from "@/api/measurement";
import {
  shareCon
} from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import {
  setTimeout
} from 'timers';

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
      return {
        body_show: false,
        data: {},
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: ""
        },
        isShow: false,
        cd_list: [],
        chartData: {
          columns: ['技能名称', '技能得分'],
          rows: []
        },
        chartSettings :{}
      }
    },
    components:{
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
      toAdvertising(val){
        window.location.href = val;
      },
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        ceping57_report({
            token: this.$route.query.token
          })
          .then((data) => {
            this.$toast.clear();
            this.data = data;
            if (data.code != '10002') {
              document.title = data.headtitle;
              this.body_show = true;
              this.data = data;
              this.qrcode = data.qrcode;
              if (!this.data.subscribe && this.data.need_subscribe) {
                this.isShow = true;
              };
              this.cd_list = ["A市场能力：A1-行业认知能力，A2-调研分析能力。", "B产品能力：B1-产品设计能力，B2-产品规划创新，B3-用户需求分析。", "C运营能力：C1-运营数据分析，C2-营销推广策略，C3-渠道管理能力，C4-危机管理能力。","D项目管理能力：指的是策划、实施、监督执行项目的能力。"]
              this.chartSettings = {
                metrics: ['技能得分'],
                // dataOrder: {
                //   label: '技能得分',
                //   order: 'desc'
                // },
                itemStyle: {
                  color: "#36B0BB",
                }
              };
              // for(let attr in this.data.list_10){
              //   this.chartData.rows.push({"技能名称":attr,"技能得分":this.data.list_10[attr]})
              // }

              this.chartData.rows.unshift({"技能名称":'A1行业认知能力',"技能得分":this.data.list_10['行业认知']});
              this.chartData.rows.unshift({"技能名称":'A2调研分析能力',"技能得分":this.data.list_10['调研分析能力']});
              this.chartData.rows.unshift({"技能名称":'B1产品设计能力',"技能得分":this.data.list_10['产品设计']});
              this.chartData.rows.unshift({"技能名称":'B2产品规划创新',"技能得分":this.data.list_10['产品规划创新']});
              this.chartData.rows.unshift({"技能名称":'B3用户需求分析',"技能得分":this.data.list_10['用户需求分析']});
              this.chartData.rows.unshift({"技能名称":'C1运营数据分析',"技能得分":this.data.list_10['运营数据分析']});
              this.chartData.rows.unshift({"技能名称":'C2营销推广策略',"技能得分":this.data.list_10['营销推广策略']});
              this.chartData.rows.unshift({"技能名称":'C3渠道管理能力',"技能得分":this.data.list_10['渠道管理']});
              this.chartData.rows.unshift({"技能名称":'C4危机管理能力',"技能得分":this.data.list_10['危机管理']});
              this.chartData.rows.unshift({"技能名称":'D 项目管理能力',"技能得分":this.data.list_10['项目管理']});

              // 给wxconfig传对象
              this.type_obj.nickname = data.nickname;
              this.type_obj.evaluation_id = data.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = String(data.uid);
              this.type_obj.path = this.$route.path;

              shareCon("ceping57", this, this.type_obj);
              setTimeout(() => {
                // 第一部分
                this.dashboard_chart();
                // 第二部分
                // this.dimension_chart();
              }, 1000);
            } else {
              // 已经测评完成
              this.$router.push('/ceping57')
            }
          })
      },
      // 总体水平
      dashboard_chart() {
        let myChart = echarts.init(document.getElementById('dashboard'));
        window.onresize = myChart.resize;
        let option = {
          center: ['50%', '50%'],
          series: [{
            type: 'gauge',
            radius: '96%',
            animationDurationUpdate: 1500,
            animationEasingUpdate: 'quadraticOut',
            detail: {
              textStyle: {
                fontSize: 24
              },
              offsetCenter: [0, '70%']
            },
            splitLine: { //分割线样式
              length: 20
            },
            pointer: {
              length: '60%',
              width: 4

            },
            axisLine: {
              lineStyle: {
                color: [
                  [this.data.score / 100, '#36B0BB'],
                  [1, '#1B294E']
                ],
                width: 20 // 这个是修改宽度的属性
              }
            },
            data: [{
              value: ''
            }]
          }]
        };
        myChart.setOption(option);
        myChart.setOption({
          series: [{
            name: '总体水平',
            type: 'gauge',
            data: [{
              value: this.data.score
            }]
          }]
        });
      },
      // 维度剖析
      // dimension_chart() {
      //   let dimension = echarts.init(document.getElementById('dimension'));
      //   let dimension_indicator = [];
      //   let dimension_value = [];

      //   for (let attr in this.data.list_4) {
      //     dimension_indicator.push({
      //       text: attr,
      //       max: 5
      //     });
      //     dimension_value.push(this.data.list_4[attr]);
      //   }
      //   let option = {
      //     tooltip: {
      //       trigger: 'axis'
      //     },
      //     polar: [{
      //       indicator: dimension_indicator
      //     }],
      //     series: [{
      //       type: 'radar',
      //       areaStyle: {
      //         normal: { //区域填充样式
      //           color: '#36b0bb',
      //           opacity: '0.8'
      //         }
      //       },
      //       itemStyle: { //折线拐点标志的样式
      //         color: '#36b0bb',
      //       },
      //       data: [{
      //         name: '得分',
      //         value: dimension_value,
      //         label: {
      //           normal: {
      //             show: true,
      //             formatter: function(params) {
      //               return params.value;
      //             }
      //           }
      //         }
      //       }]
      //     }]
      //   };

      //   // 为echarts对象加载数据
      //   dimension.setOption(option);
      // },
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.meacur_top {
  background: url(../../../assets/57_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 414px;
  padding: 0 changeRem(.6) + px;
  padding-top: changeRem(.65) + px;
  text-align: left;
  h2 {
    font-size: changeRem(1.08) + px;
    line-height: changeRem(1.6) + px;
    color: #fff;
    width: changeRem(8.8) + px;
    font-weight: bold;
  }
}

.meacur_tx {
  margin-top: 195px;
  img {
    border-radius: 50%;
    width: changeRem(2) + px;
    height: changeRem(2) + px;
    float: left;
  }
}

.meacur_txr {
  float: left;
  margin-left: changeRem(.5) + px;
  h3 {
    color: #fff;
    font-size: changeRem(.64) + px;
    line-height: changeRem(1.1) + px;
  }
  h4 {
    color: #fff;
    font-size: changeRem(.52) + px;
    line-height: changeRem(.7) + px;
  }
}

.meacur_main {
  width: 690px;
  background: #fff;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 40px;
  padding: 60px 30px;
  text-align: center;
  .mea_tb {
    text-align: center;
    color: #333;
    display: block;
    margin: 0 auto;
    width: 480px;
    height: 60px;
    border: 4px solid rgba(54, 176, 187, 1);
    border-radius: 30px;
    position: relative;
    span {
      display: inline-block;
      width: 480px;
      height: 60px;
      background: rgba(27, 41, 78, 1);
      border-radius: 30px;
      position: absolute;
      top: -12px;
      left: -12px;
      line-height: 60px;
      color: #fff;
      font-size: 36px;
    }
  }
  p {
    color: #333;
    font-size: 28px;
    line-height: 42px;
    text-align: justify;
    margin-top: 30px;
  }
}

.meacur_mains {
  margin-top: -60px;
}

.advertising{
  margin: 40px auto;
  ul li{
    margin-top: 40px;
    text-align: left;
    color: #333333;
    div.left{
      float: left;
      h3{
        font-size: 30px;
        font-weight: bold;
      }
      p{
        font-size: 28px;
        margin-top: 0;
      }
    }
    img{

      float: right;
      margin-right: 30px;
      width: 114px;
      height: 106px;
    }
  }
}

// 仪表盘
.dashboard {
  height: 400px;
  margin: 0 auto;
  margin-top: 60px;
  border-bottom: 2px dashed #ccc;
}

.meacur_p {
  text-align: center;
  margin-top: 60px;
  h4 {
    color: #333;
    font-size: 28px;
  }
  h3 {
    color: #1B294E;
    font-size: 32px;
    margin-top: 20px;
    font-weight: bold;
  }
}

.dimension {
  margin: 0 auto;
  height: 500px;
  margin: 30px auto;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  position: relative;
  border-bottom: 2px dashed #ccc;
  padding-bottom: 30px;
}

.cdhs ul li {
  margin-top: 40px;
  span {
    width: 11px;
    height: 11px;
    background: rgba(54, 176, 187, 1);
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
  }
  .sch_r {
    float: right;
    width: 584px;
    line-height: 40px;
    font-size: 28px;
    color: #333;
    text-align: justify;
  }
}
.vs_t {
  margin-top: -40px;
}
.dxs {
  height: 100px;
  background: #fff;
    z-index: 10;
    position: relative;
}
.scrie {
  font-size: 30px;
  color: #333;
  font-weight: bold;
  text-align: left;
  margin-top: 30px;
}
</style>
